'use client'

import React from 'react'
import Seo from '../../components/Seo'
import { Mail } from 'lucide-react'

const PrivacyPolicyPage = () => {
  const pageUrl = '/privacy-policy'

  return (
    <>
      <Seo
        title="Privacy Policy – Xentovra Global"
        description="Learn about Xentovra Global's privacy policy and how we protect your personal information and data."
        url={pageUrl}
        breadcrumbItems={[
          { name: 'Home', url: 'https://www.xentovra-globals.com/' },
          { name: 'Privacy Policy', url: 'https://www.xentovra-globals.com/privacy-policy' },
        ]}
      />
      
      <main className="privacy-policy bg-light-blue">
        <div className="page-header-section">
          <h1 className="section-heading">
            Privacy Policy
          </h1>
          <p className="update-date"> Update Date : Nov 1 2025 </p>
        </div>
        <section className="section-padding privacy-policy-section">
          <div className="section-container">
            <div className="privacy-content">
              <div className="privacy-text">
                <p className="normal-text company-description">
                  At Xentovra Global, we value your trust and are committed to protecting your privacy. 
                  This Privacy Policy explains how we collect, use, and safeguard the information you 
                  provide to us through our website and services.
                </p>
               <div className="privacy-text-content"> 
                  <h2 className="text-heading">1. Information We Collect</h2>      
                  <h3 className="sub-heading">Personal Information:</h3>
                  <p className="normal-text">Name, email address, phone number, company details, or any other information you voluntarily share.</p>           
                  <h3 className="sub-heading">Non-Personal Information:</h3>
                  <p className="normal-text">Browser type, device, IP address, and usage data collected through cookies and analytics tools.</p>
                </div>
                <div className="privacy-text-content"> 
                  <h2 className="text-heading">2. How We Use Your Information</h2>
                  <ul>
                    <li className="normal-text">To respond to your inquiries and provide requested services.</li>
                    <li className="normal-text">To improve our website, customer support, and business operations.</li>
                    <li className="normal-text">To send updates, marketing communications, and service-related notices (you may opt out anytime).</li>
                    <li className="normal-text">To comply with legal and regulatory requirements.</li>
                  </ul>
                </div>
                <div className="privacy-text-content"> 
                <h2 className="text-heading">3. Data Protection</h2>
                <p className="normal-text">
                  We implement appropriate technical and organizational measures to safeguard your information 
                  against unauthorized access, alteration, or disclosure.
                </p>
                </div>
                <div className="privacy-text-content"> 
                <h2 className="text-heading">4. Sharing of Information</h2>
                <ul>
                  <li className="normal-text">We do not sell or rent your personal data.</li>
                  <li className="normal-text">Information may be shared with trusted partners or service providers solely to deliver our services.</li>
                  <li>We may disclose information if required by law or to protect our legal rights.</li>
                </ul>
                </div>
                <div className="privacy-text-content"> 
                <h2 className="text-heading">5. Your Rights</h2>
                <ul>
                  <li className="normal-text">Request access, correction, or deletion of your personal data.</li>
                  <li className="normal-text">Opt out of marketing emails at any time.</li>
                </ul>
                </div>
                <div className="privacy-text-content"> 
                  <h2 className="text-heading">6. Contact Us</h2>
                  <p className="normal-text mb-8">For questions about this Privacy Policy, contact us at:</p>
                  <p className="normal-text">
                     <a href="mailto:info@xentovra-globals.com" className="contact-link"> <Mail size={16} strokeWidth={2} /> info@xentovra-globals.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export default PrivacyPolicyPage
